export default {
    host: 'https://dswisej.dyndns.org/restapi/api',
}
